import { render, staticRenderFns } from "./oddsItemMMOX.vue?vue&type=template&id=54ac989d&lang=pug&"
import script from "./oddsItemMMOX.vue?vue&type=script&lang=js&"
export * from "./oddsItemMMOX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports